export default __webpack_public_path__ + "static/media/envBanner.22dda1fa.jpg";